import React from 'react';
import ServiceComponent from './ServiceComponent';
import {Helmet} from 'react-helmet'
export default function MarketingComponent() {

  const description = <>
                        <p className="mb-14">Diseñamos estrategias que integren los canales digitales y cumplan con los objetivos de negocio.</p>
                        <p>Creamos estrategias de contenido para cada canal digital.</p>
                      </>

  return (
    <>
    <Helmet>
      <title>Servicios de Marketing Digital | Blue Group Marketing | Bolivia</title>
      <meta
        name="description"
        content="Estrategias de Marketing Digital integradas: gestión de redes sociales, diseño y desarrollo de páginas web, y optimización de pauta publicitaria digital en Bolivia."
      />
      <meta name="keywords" content="marketing digital, redes sociales, diseño web, desarrollo web, pauta digital, publicidad online, cochabamba, bolivia" />
      <meta name="robots" content="index, follow"/>
      <meta name="googlebot" content="index, follow"/>
      <link rel="canonical" href={`${process.env.FRONTENDURL}MarketingServices`} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content="Blue Group Marketing" />
      <meta property="og:url" content={`${process.env.FRONTENDURL}MarketingServices`} />
      <meta property="og:title" content="Servicios de Marketing Digital | Blue Group Marketing | Bolivia" />
      <meta property="og:description" content="Estrategias de Marketing Digital integradas: gestión de redes sociales, diseño y desarrollo de páginas web, y optimización de pauta publicitaria digital en Bolivia." />
      <meta property="og:image" content="https://bluegroupmarketing.com/bluegroupog.jpg" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Servicios de Marketing Digital | Blue Group Marketing | Bolivia" />
      <meta name="twitter:description" content="Estrategias de Marketing Digital integradas: gestión de redes sociales, diseño y desarrollo de páginas web, y optimización de pauta publicitaria digital en Bolivia." />
      <meta name="twitter:image" content="https://bluegroupmarketing.com/bluegroupog.jpg" />
    </Helmet>
    <ServiceComponent description={description} service="MARKETING DIGITAL" type="Marketing">
      <div className="mx-auto" style={{maxWidth:"1400px"}}>
      <ul className="text-lg lg:text-2xl xl:text-3xl mt-20 text-center md:text-left">
        <li className="mb-20 flex justify-center flex-wrap md:flex-nowrap md:justify-start">
          <div>
            <img className="w-20 mx-auto sm:mx-5" alt="Icono de Administración de Redes Sociales" src={require('../../assests/OurServices/Marketing/admin_icon.png')}/>
          </div>
          <div className="individual-content">
            <h2 className="text-bluegroup-800 italic font-bold">Administración de Redes Sociales</h2>
            <p className="text-bluegroup-100">Diseñamos contenido audiovisual totalmente atractivo y dirigido a la audiencia meta.</p>
          </div>
        </li>
        <li className="mb-20 flex flex-wrap justify-center flex-wrap md:flex-nowrap md:justify-start">
          <div>
            <img className="sm:inline w-20 mx-auto sm:mx-5" alt="Icono de Diseño y desarrollo de página web" src={require('../../assests/OurServices/Marketing/design_icon.png')}/>
          </div>
          <div className="individual-content">
            <h2 className="text-bluegroup-300 italic font-bold"> Diseño y desarrollo de página web</h2>
            <p className="text-bluegroup-100">Creamos Sitios Web personalizados, que reflejan la identidad de la marca. Trabajamos para que tu negocio sea visible, único y seguro.</p>
          </div>
        </li>
        <li className="mb-20 flex flex-wrap justify-center flex-wrap md:flex-nowrap md:justify-start">
          <div>
            <img className="sm:inline w-20 mx-auto sm:mx-5" alt="Icono de Pauta publicitaria digital" src={require('../../assests/OurServices/Marketing/pauta_icon.png')}/>
          </div>
          <div className="individual-content">
            <h2 className="text-bluegroup-100 italic font-bold">Pauta publicitaria digital</h2>
            <p className="text-bluegroup-100">Optimizamos la inversión de pauta en canales digitales, monitoreamos la inversión para maximizar los resultados.</p>
          </div>
        </li>
      </ul>
      </div>
    </ServiceComponent>
    </>
  );
}